export const renderIcon = (type: string, child: any, className?: any) =>
{
      // child = {
      //       "name": "data:image/png;base64,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",
      //             "type": "embed_base64"
      // }
      const classIcon = "!w-[28px] !h-[28px] !min-w-[28px]";
      switch (type)
      {
            case "static":
                  return (
                        <img
                              className={className ? className : classIcon}
                              src={child?.name ?? "/default-logo.png"}
                              alt=""
                        />
                  );
            case "embed_base64":
                  return (
                        <img
                              src={child?.name ?? "/default-logo.png"}
                              alt=""
                              className={className ? className : classIcon}
                        />
                  );
            default:
                  return <i className={`${child?.name} w-[20px] h-[20px]`} />;
      }
};
const LINK_ID = "active-theme-css";
export function loadThemeCss(file: string)
{
      // const themeFileRegex = /^theme-[a-z0-9-]+\.css$/i;

      // if (!themeFileRegex.test(file))
      // {
      //       console.error(
      //             "Security Alert: Tên file theme không đúng định dạng (theme-xxx.css)"
      //       );
      //       return;
      // }
      const old = document.getElementById(LINK_ID);
      if (old) old.remove();

      // Normalize: accept "dark", "theme-dark", "theme-dark.css", "dark.css" →
      // theme name "dark", so the href is always /themes/theme-dark.css.
      const name = String(file ?? "")
            .replace(/^theme-/, "")
            .replace(/\.css$/, "");
      if (!name) return;

      const link = document.createElement("link");
      link.id = LINK_ID;
      link.rel = "stylesheet";
      link.href = `/themes/theme-${name}.css?v=${Date.now()}`;

      document.head.appendChild(link);
}
